const initialState = {
    isLoading : true,
    hasError  : false,
    data      : null,
    selected  : null,
};

const processDestinationSelected = (state, destination) => {
    // The ?countries and ?cities format is necessary for NTP's search endpoint
    const processedDestination = destination;

    if (destination.type === 'country') {
        processedDestination.value = `?countries=${destination.value}`;
    }

    if (destination.type === 'city') {
        processedDestination.value = `?cities=${destination.value}`;
    }

    return {
        ...state,
        isLoading : false,
        hasError  : false,
        selected  : processedDestination,
    };
};

const destinationsReducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case 'GET_DESTINATIONS_REQUEST_START':
            return {
                ...state,
                isLoading : true,
                hasError  : false,
            };
        case 'GET_DESTINATIONS_REQUEST_FAILURE':
            return {
                ...state,
                isLoading : false,
                hasError  : true,
            };
        case 'GET_DESTINATIONS_REQUEST_SUCCESS':
            return {
                ...state,
                isLoading : false,
                hasError  : false,
                data      : action.payload,
                selected  : action.payload.selected,
            };
        case 'DESTINATION_SELECTION':
            return processDestinationSelected(state, action.payload);
        default:
            return state;
    }
};

export default destinationsReducer;
